function closeCart () {
  
  cartElements = document.getElementsByClassName('theme-ajax-cart');
  cartOverlays = document.getElementsByClassName('ajax-cart__overlay');
  
  for(var i = 0; i < cartElements.length; i++) {
    cartElements[i].classList.remove('is-visible');
  }

  for(var i = 0; i < cartOverlays.length; i++) {
    cartOverlays[i].classList.remove('is-visible');
  }

}